import { InputBase, styled } from "@mui/material";

export const StyledPaper = styled("div")`
  background-color: #282828; /* TODO - change to theme color Neutral/100 text */
  padding: 0;
`;

export const StyledMenu = styled("div")``;

export const StyledMenuList = styled("div")`
  background-color: #282828; /* TODO - change to theme color Neutral/100 text */
  & {
    padding: 0;
  }
`;

export const StyledDropdownInput = styled(InputBase)(({ theme }) => ({
  "&.DropdownStyle-Default": {
    width: "100%",
    "&& .MuiInputBase-input": {
      borderRadius: theme.wsc.radius.m,
      position: "relative",
      backgroundColor: "#282828", // TODO - change to theme color Neutral/100 text,
      border: "1px solid #404040", // TODO - change to theme color Neutral/500,
      color: "#BABABA", // TODO - change to theme color Neutral/200,
      padding: `${theme.wsc.spacing[0]} ${theme.wsc.spacing[1]}`,
      paddingRight: theme.wsc.spacing[3],
      "&:hover": {
        backgroundColor: "#333", // TODO - change to theme color Neutral/600,
        borderColor: "#333", // TODO - change to theme color Neutral/600,
      },
      "&:focus": {
        borderColor: "#80bdff",
        borderRadius: theme.wsc.radius.m,
      },
    },

    "&& .MuiSelect-select": {
      display: "flex",
      minHeight: "1.571rem",
    },

    "&& .MuiSelect-icon": {
      top: "calc(50% - 0.55em)",
    },

    "&.Mui-focused": {
      "&& .MuiInputBase-input": {
        backgroundColor: "#404040", // TODO - change to theme color Neutral/500,
        borderColor: "#fff", // TODO - change to theme color Neutral/0,
      },
    },

    "&.Mui-disabled": {
      "&& .MuiInputBase-input": {
        backgroundColor: "#181818", // TODO - change to theme color Neutral/800,
        borderColor: "#404040", // TODO - change to theme color Neutral/500,
        color: "#8E8E8E", // TODO - change to theme color Neutral/300,
        WebkitTextFillColor: "#8E8E8E", // TODO - change to theme color Neutral/300,
      },
    },

    "&.Mui-error": {
      "&& .MuiInputBase-input": {
        borderColor: "#FF3131", // TODO - change to theme color Warning/300,
      },
    },

    "& .MuiSelect-icon": {
      color: "rgba(240, 240, 240, 1)", // TODO - change to theme color Neutral/100,
    },
  },
}));
